import api from "./core";

const basePath = "api/core/SystemSetting";

export default {
  get() {
    return api.get(`${basePath}`);
  },
  update(data) {
    return api.patch(`${basePath}`, data);
  }
};
